import { useState } from "react";
import { Link } from "react-router-dom";
import DeleteProjectModal from "../../../../../components/Modals/DeleteProjectModal";
import { btn } from "../../../../../components/Button/buttonStyles";

const Card = ({ children }) => (
  <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-5 space-y-3">
    {children}
  </div>
);

const Field = ({ label, value }) => {
  const isEmpty = value === null || value === undefined || value === "";
  return (
    <div className="flex items-start text-sm">
      <span className="w-40 shrink-0 text-xs font-medium text-gray-500 pt-px">
        {label}:
      </span>
      <span className="text-gray-900">{isEmpty ? "—" : value}</span>
    </div>
  );
};

const btnPrimary = btn("primary", "sm");
const btnDanger = btn("danger", "sm");

const ProjectDetailsCard = ({ project, onEdit, onDelete }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  const formatDateTime = (date) =>
    new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  const clientName =
    project.client?.company_name ||
    `${project.client?.primary_user?.first_name || ""} ${
      project.client?.primary_user?.last_name || ""
    }`.trim() ||
    "";

  const clientValue = project.client?.id ? (
    <Link
      to={`/clients/${project.client.id}`}
      className="text-brand-600 hover:text-brand-800 underline font-medium"
    >
      {clientName || "—"}
    </Link>
  ) : (
    clientName
  );

  const languagePairsValue =
    project.languagePairs && project.languagePairs.length > 0 ? (
      <div className="flex flex-wrap gap-2">
        {project.languagePairs.map((lp, index) => (
          <span
            key={index}
            className="border rounded-md px-2 py-0.5 text-xs bg-gray-50 text-gray-700"
          >
            {lp.sourceLanguage?.name} → {lp.targetLanguage?.name}
          </span>
        ))}
      </div>
    ) : (
      ""
    );

  const instructionsValue = project.instructions ? (
    <div
      className="prose prose-sm max-w-none text-gray-900"
      dangerouslySetInnerHTML={{ __html: project.instructions }}
    />
  ) : (
    ""
  );

  return (
    <section>
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl font-bold text-gray-900">Project Details</h2>
        <div className="flex items-center gap-2 text-sm">
          <button onClick={onEdit} className={btnPrimary}>
            Update
          </button>
          <button
            onClick={() => setIsModalOpen(true)}
            className={btnDanger}
          >
            Delete
          </button>
        </div>
      </div>

      <Card>
        <Field label="Client" value={clientValue} />
        <Field
          label="Contact Person"
          value={
            project.contactPerson
              ? `${project.contactPerson.first_name} ${project.contactPerson.last_name}`
              : ""
          }
        />
        <Field label="Project Code" value={project.project_code} />
        <Field label="Project Name" value={project.project_name} />
        <Field label="Service" value={project.service?.name} />
        <Field label="Language Pairs" value={languagePairsValue} />
        <Field label="Specialization" value={project.specialization?.name} />
        <Field
          label="Start At"
          value={project.start_at ? formatDateTime(project.start_at) : ""}
        />
        <Field
          label="Deadline At"
          value={
            project.deadline_at ? formatDateTime(project.deadline_at) : ""
          }
        />
        <Field label="Instructions" value={instructionsValue} />
        <Field label="Legal Entity" value={project.legal_entity} />
        <Field label="Internal Note" value={project.internal_note} />
        <Field
          label="Created At"
          value={project.createdAt ? formatDate(project.createdAt) : ""}
        />
      </Card>

      {isModalOpen && (
        <DeleteProjectModal
          projectId={project.id}
          projectName={project.project_name}
          projectCode={project.project_code}
          onCancel={() => setIsModalOpen(false)}
          onConfirm={onDelete}
        />
      )}
    </section>
  );
};

export default ProjectDetailsCard;
